import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from './paymentButton.styles';
import { PaymentStatus } from '../../../modules/booking/booking.constants';
import messages from './messages';

export class PaymentButton extends PureComponent {
  static propTypes = {
    paymentStatus: PropTypes.oneOf([
      PaymentStatus.PENDING,
      PaymentStatus.SUCCESSFUL,
      PaymentStatus.FAILED,
      PaymentStatus.INITIAL,
    ]),
    closeKeyboard: PropTypes.func.isRequired,
  };

  get isDisabled() {
    return this.props.paymentStatus === PaymentStatus.PENDING;
  }

  handleClick = () => {
    document.body.dispatchEvent(new Event('resetTimeout'));
    this.props.closeKeyboard();
  };

  renderLabel = () => {
    const key = this.props.paymentStatus === PaymentStatus.PENDING ? 'pendingLabel' : 'defaultLabel';
    return <FormattedMessage {...messages[key]} />;
  };

  render() {
    return (
      <Fragment>
        <Button onClick={this.handleClick} disabled={this.isDisabled} dark>
          {this.renderLabel()}
        </Button>
      </Fragment>
    );
  }
}
